// extracted by mini-css-extract-plugin
module.exports = {"subText":"overlay_subText__r7R5c","container":"overlay_container__hKGxi","closeButton":"overlay_closeButton__Beelf","contentContainer":"overlay_contentContainer__efQ2x"};